// extracted by mini-css-extract-plugin
export default {"wrapper":"Eingabe_wrapper__oy2A5","focus":"Eingabe_focus__3zRvR","inline":"Eingabe_inline__nddKI"};